module.exports = function() {
  return new Worker("./" + "sass-transpiler.3c56e7c5.worker.js");
};